import { MonitorsTable } from './MonitorsTable';
import { MonitorUpsellCard } from './MonitorUpsellCard';
import React from 'react';
import { Space } from 'antd';
import { ViewArea } from '@ui/general';
export const MonitorsView = () => React.createElement(ViewArea, { collapseSidebar: true, direction: 'vertical', fullWidth: true, id: 'data-security-monitors-view' },
    React.createElement(Space, { direction: 'vertical' },
        React.createElement(MonitorUpsellCard, null),
        React.createElement(MonitorsTable, null)));
